module.exports = __webpack_public_path__ + "static/ben-8d508634a27e38b99794f7a396a741a9.png";